import { Text, useText } from "@sveabank/cc-common";
import type { OnboardingPackageId } from "../../../types/package";

export const PromotedTagWrapper = ({
	isPromoted,
	packageId,
	children,
}: {
	isPromoted: boolean;
	packageId: OnboardingPackageId;
	children: React.ReactNode;
}) => {
	const [t, texts] = useText();
	const text = texts.choosePackage[packageId];
	const promoText = text && "promo" in text ? text.promo : undefined;
	const promoMobileText = text && "promoMobile" in text ? text.promoMobile : undefined;

	return (
		<div className="relative h-full">
			{isPromoted && promoText && promoMobileText && (
				<div className="bg-text-alert text-text-contrast absolute top-0 right-0 z-50 rounded-tr-lg rounded-bl-lg px-3 py-1 text-xs font-bold">
					<Text italic className="tablet:block text-text-contrast hidden">
						{t(promoText)}
					</Text>

					<Text italic className="tablet:hidden text-text-contrast block text-sm">
						{t(promoMobileText)}
					</Text>
				</div>
			)}
			{children}
		</div>
	);
};
